import { getPermissionMap } from '@app/hooks/use-permission-verify';
import store from '@app/store';
import { StateType } from '@app/types/reducer-state';

export { default } from '@app/hooks/use-permission-verify';

/**
 * Use verifyPermission to retrieve data because hook cannot be used outside react component
 * @param permissions Array of permissions to verify
 * returns Object with user's permissions as keys
 */
export const verifyPermission = (permissions: Array<string>) => {
  const state = store.getState() as unknown as StateType;
  return getPermissionMap(state?.auth?.permissions, permissions || []);
};
